import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { d as defineCustomElement$2 } from './pds-icon2.js';

const pdsToastCss = ":host{--animation-duration:0.3s;--animation-timing:cubic-bezier(0.4, 0, 0.2, 1);--padding-inline:var(--pine-dimension-md);--padding-inline-desktop:var(--pine-dimension-2xl);--sizing-height-default:68px;--sizing-min-width:calc(var(--sizing-total-width) - (var(--padding-inline) * 2));--sizing-min-width-desktop:calc(var(--sizing-total-width) - (var(--padding-inline-desktop) * 2));--sizing-total-width:350px;-webkit-box-sizing:border-box;box-sizing:border-box;display:block;font:var(--pine-typography-body-medium)}.pds-toast{-ms-flex-align:center;align-items:center;-webkit-animation:pds-toast-animate-in var(--animation-duration) var(--animation-timing);animation:pds-toast-animate-in var(--animation-duration) var(--animation-timing);background-color:var(--pine-color-primary);border-radius:var(--pine-dimension-xs);-webkit-box-shadow:var(--pine-box-shadow);box-shadow:var(--pine-box-shadow);color:var(--pine-color-text-primary);display:-ms-flexbox;display:flex;height:var(--sizing-height-default);-ms-flex-pack:start;justify-content:flex-start;-webkit-margin-after:var(--pine-dimension-2xs);margin-block-end:var(--pine-dimension-2xs);max-width:90vw;min-width:var(--sizing-min-width);padding:0 var(--padding-inline);position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content}@media screen and (max-width: 767px){.pds-toast{height:36px;max-width:calc(100vw - var(--pine-dimension-2xs) * 2);min-width:auto;padding-inline:var(--pine-dimension-2xs)}}.pds-toast--danger{background-color:var(--pine-color-danger)}.pds-toast--loading .pds-toast__loader{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-margin-end:var(--pine-dimension-sm);margin-inline-end:var(--pine-dimension-sm);position:relative}.pds-toast--loading .pds-toast__loader-spinner{-webkit-animation:pds-toast-rotate 2s linear infinite;animation:pds-toast-rotate 2s linear infinite;height:20px;width:20px}.pds-toast--loading .pds-toast__loader-path{-webkit-animation:pds-toast-dash 1.5s ease-in-out infinite;animation:pds-toast-dash 1.5s ease-in-out infinite;stroke-dasharray:1, 200;stroke-dashoffset:0;stroke-linecap:round}.pds-toast__icon{color:var(--pine-color-text-primary);display:-ms-inline-flexbox;display:inline-flex;-webkit-margin-end:var(--pine-dimension-sm);margin-inline-end:var(--pine-dimension-sm)}.pds-toast__message{font:var(--pine-typography-body-sm-medium);-webkit-margin-end:auto;margin-inline-end:auto;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.pds-toast__message ::slotted(a){color:var(--pine-color-text-primary);-webkit-margin-start:var(--pine-dimension-xs);margin-inline-start:var(--pine-dimension-xs);opacity:0.7;text-decoration:underline}.pds-toast__message ::slotted(a):hover,.pds-toast__message ::slotted(a):focus-visible{opacity:1}.pds-toast__message ::slotted(a):focus-visible{outline:2px solid var(--pine-color-text-primary);outline-offset:2px}.pds-toast__button{-ms-flex-align:center;align-items:center;background:none;border:0;border-radius:var(--pine-border-radius-full);color:inherit;cursor:pointer;display:-ms-inline-flexbox;display:inline-flex;-webkit-margin-start:var(--pine-dimension-md);margin-inline-start:var(--pine-dimension-md);opacity:0.7;padding:0;white-space:nowrap}.pds-toast__button:hover,.pds-toast__button:focus{opacity:1}.pds-toast__button:focus{outline:var(--pine-outline-focus);outline-offset:var(--pine-dimension-2xs)}@-webkit-keyframes pds-toast-animate-in{from{opacity:0;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes pds-toast-animate-in{from{opacity:0;-webkit-transform:translateY(100%);transform:translateY(100%)}to{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes pds-toast-animate-out{from{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(100%);transform:translateY(100%)}}@keyframes pds-toast-animate-out{from{opacity:1;-webkit-transform:translateY(0);transform:translateY(0)}to{opacity:0;-webkit-transform:translateY(100%);transform:translateY(100%)}}@-webkit-keyframes pds-toast-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes pds-toast-rotate{to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@-webkit-keyframes pds-toast-dash{0%{stroke-dasharray:1, 200;stroke-dashoffset:0}50%{stroke-dasharray:89, 200;stroke-dashoffset:-35}100%{stroke-dasharray:89, 200;stroke-dashoffset:-124}}@keyframes pds-toast-dash{0%{stroke-dasharray:1, 200;stroke-dashoffset:0}50%{stroke-dasharray:89, 200;stroke-dashoffset:-35}100%{stroke-dasharray:89, 200;stroke-dashoffset:-124}}:host([hidden]) .pds-toast,.pds-toast--animating-out{-webkit-animation:pds-toast-animate-out var(--animation-duration) var(--animation-timing) forwards;animation:pds-toast-animate-out var(--animation-duration) var(--animation-timing) forwards;pointer-events:none;}";

const PdsToast$1 = /*@__PURE__*/ proxyCustomElement(class PdsToast extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.pdsToastDismissed = createEvent(this, "pdsToastDismissed", 7);
        /**
         * Whether the toast can be dismissed manually via the close button.
         * Note: This only controls manual dismissal. Auto-dismissal via duration still applies.
         * @default true
         */
        this.dismissible = true;
        /**
         * The duration in milliseconds to show the toast before auto-dismissing.
         * Set to 0 to disable auto-dismiss.
         * @default 4500
         */
        this.duration = 4500;
        /**
         * The type of toast to display.
         * - default: Grey background (default)
         * - danger: Red background
         * - loading: With spinner animation
         * @default 'default'
         */
        this.type = 'default';
        /**
         * Whether the toast is currently visible.
         */
        this.isVisible = true;
        /**
         * Whether the toast is animating out.
         */
        this.isAnimatingOut = false;
    }
    componentDidLoad() {
        if (this.duration > 0) {
            this.startDismissTimer();
        }
    }
    disconnectedCallback() {
        this.cleanup();
    }
    handleDurationChange(newDuration) {
        if (this.dismissTimer) {
            window.clearTimeout(this.dismissTimer);
            this.dismissTimer = undefined;
        }
        if (newDuration > 0) {
            this.startDismissTimer();
        }
    }
    async dismiss() {
        // Start the animation out
        this.isAnimatingOut = true;
        // Wait for animation to complete before hiding and cleanup
        await new Promise((resolve) => setTimeout(resolve, 300)); // Match --animation-duration
        this.isVisible = false;
        this.cleanup();
        this.pdsToastDismissed.emit({ componentId: this.componentId });
    }
    // Private methods
    cleanup() {
        if (this.dismissTimer) {
            window.clearTimeout(this.dismissTimer);
            this.dismissTimer = undefined;
        }
    }
    startDismissTimer() {
        this.dismissTimer = window.setTimeout(() => {
            this.dismiss();
        }, this.duration);
    }
    renderIcon() {
        // Loading type takes priority
        if (this.type === 'loading') {
            return (h("div", { class: "pds-toast__loader" }, h("svg", { class: "pds-toast__loader-spinner", viewBox: "25 25 50 50", "aria-hidden": "true" }, h("circle", { class: "pds-toast__loader-path", cx: "50", cy: "50", r: "20", fill: "none", stroke: "currentColor", "stroke-width": "4", "stroke-linecap": "round" }))));
        }
        // Return icon if provided, otherwise undefined (which renders as nothing)
        return this.icon && h("pds-icon", { name: this.icon, class: "pds-toast__icon" });
    }
    render() {
        return (h(Host, { key: 'c950cf3a269952f6048f79e5c6c793c65ff2b89a', hidden: !this.isVisible }, h("div", { key: '0cec10124aecec0c7af86b460165a577c65d1571', class: {
                'pds-toast': true,
                [`pds-toast--${this.type}`]: this.type !== 'default',
                'pds-toast--animating-out': this.isAnimatingOut
            }, role: "alert", "aria-live": "polite" }, this.renderIcon(), h("span", { key: '5dda529f788df94ed0e444924fb11a1061a20dd1', class: "pds-toast__message" }, h("slot", { key: '29a6c93dbf14f92b1375eff7a3c8f4556babe67a' })), this.dismissible && (h("button", { key: 'f3bcbcacceb5ef2b1d2127d408879e2a95418230', type: "button", class: "pds-toast__button", onClick: () => {
                this.dismiss();
            }, "aria-label": "Dismiss message" }, h("pds-icon", { key: '1ea48def81a89dc7ba38f493abb0107632005075', name: "remove" }))))));
    }
    static get watchers() { return {
        "duration": ["handleDurationChange"]
    }; }
    static get style() { return pdsToastCss; }
}, [1, "pds-toast", {
        "componentId": [1, "component-id"],
        "dismissible": [4],
        "duration": [2],
        "icon": [1],
        "type": [1],
        "isVisible": [32],
        "isAnimatingOut": [32],
        "dismiss": [64]
    }, undefined, {
        "duration": ["handleDurationChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["pds-toast", "pds-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "pds-toast":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PdsToast$1);
            }
            break;
        case "pds-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const PdsToast = PdsToast$1;
const defineCustomElement = defineCustomElement$1;

export { PdsToast, defineCustomElement };
//# sourceMappingURL=pds-toast.js.map

//# sourceMappingURL=pds-toast.js.map